import type { LucideIcon } from 'lucide-react'

export interface ListEmptyStateProps {
  icon: LucideIcon
  message: string
}

/** Inline empty state shown inside a list column when no items match. */
export function ListEmptyState({ icon: Icon, message }: ListEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-muted-foreground">
      <Icon className="h-12 w-12 mb-4 opacity-50" />
      <p>{message}</p>
    </div>
  )
}
